/* ViewModeComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;

/**
 * This class is used to store, and manage the CompareView.ViewMode
 */
class ViewModeComponent extends EventEmitter {
    constructor(logger, userSession, storageFactory) {
        super();
        this._logger = logger;
        this._userSession = userSession;

        this._userDataStorage = storageFactory.getRemoteStorageInstance("views", "compare_views");

        this._compactView = true;
        this._layoutView = "side-by-side";
    }

    get compactView() {
        return this._compactView;
    }

    get layoutView() {
        return this._layoutView;
    }

    set compactView(isCompactView) {
        this._compactView = isCompactView;
    }

    set layoutView(newLayoutView) {
        this._layoutView = newLayoutView;
    }

    setViewProps(isCompactView, newLayoutView) {
        if (typeof isCompactView !== "undefined") {
            this._compactView = isCompactView;
            this.userDataStorage.setData(isCompactView, "compactView");
        }
        if (typeof newLayoutView !== "undefined") {
            this._layoutView = newLayoutView;
            this.userDataStorage.setData(newLayoutView, "layoutView");
        }
        this.emit("viewModeChanged");
    }

    get userDataStorage() {
        return this._userDataStorage;
    }

    set userDataStorage(dataStorage) {
        this._userDataStorage = dataStorage;
    }

    whenStorageIsReady() {
        return Promise.resolve().then(() => {
            let compactView = this.userDataStorage.getData("compactView", true),
                layoutView = this.userDataStorage.getData("layoutView", true);
            if (typeof compactView !== "undefined") {
                this.compactView = compactView;
            }
            if (layoutView) {
                this.layoutView = layoutView;
            }
            return Promise.resolve();
        });
    }

    shutdown() {
        return this._userDataStorage.shutdown().then(
            () => {
                this._userSession = undefined;
                this._compactView = undefined;
                this._layoutView = undefined;
                this._logger = undefined;
                return Promise.resolve();
            },
            (err) => {
                this._logger.warn({ error: err }, "ViewModeComponent.shutdown() error.");
                return Promise.reject(err);
            }
        );
    }
}

module.exports = ViewModeComponent;
